import { render, staticRenderFns } from "./WorkSpacesSection.vue?vue&type=template&id=270c6c14&scoped=true&"
import script from "./WorkSpacesSection.vue?vue&type=script&lang=js&"
export * from "./WorkSpacesSection.vue?vue&type=script&lang=js&"
import style0 from "./WorkSpacesSection.vue?vue&type=style&index=0&id=270c6c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c6c14",
  null
  
)

export default component.exports